// API Configuration
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const config = {
  API_URL
};

export default config;
